import type { BizIconProps } from './base';
import BizIconSvg from './base';

/** IconNetwork — 全渠道服务：多节点互联（全渠道汇聚） */
export default function IconNetwork(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <path d="M8 4.67 3.67 11M8 4.67l4.33 6.33M4.67 12.33h6.67" />
      <circle cx="8" cy="3" r="1.33" fill="currentColor" stroke="none" />
      <circle cx="3.33" cy="12" r="1.33" fill="currentColor" stroke="none" />
      <circle cx="12.67" cy="12" r="1.33" fill="currentColor" stroke="none" />
    </BizIconSvg>
  );
}
